const AdminPageShell = ({ title, description, actions, children, testId }) => (
  <div data-testid={testId}>
    <div className="flex items-start justify-between gap-4 flex-wrap mb-8">
      <div>
        <h1 className="text-h3 mb-1" style={{ color: "var(--gg-ivory)" }}>{title}</h1>
        {description && <p className="text-small">{description}</p>}
      </div>
      {actions}
    </div>
    {children}
  </div>
);

export default AdminPageShell;
